import React from 'react';
import PageLayout from "../layouts/PageLayout";

function ConditionsOfUse() {
    return (<PageLayout title="Conditions Générales d'Utilisation">

    </PageLayout>);
}

export default ConditionsOfUse;